import React, { useState, useEffect, useRef, createRef } from 'react';
import { Modal, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as multiProductSelectAction from './store/MultiProductSelect.action';
import { getAllUnitDetails, getCostingStageList } from '../../../SystemMasters/Store/SystemMasters.action';
import { getCostingTemplateList } from '../../../Library/CostingTemplateTSX/store/costingTemplate.actions';
import Loader from '../../../../Components/Utility/Loader/Loader';
import ProductCostingDetailView from './ProductCostingDetailView';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import './MultiProductCostingSubmitModal.css';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

function MultiProductCostingSubmitModal({ mainState, toggle, listState, setProductCostingState }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { show, commonSupplierList, productData } = mainState;
  const { selectedIds } = listState;
  const childRef = useRef([]);
  childRef.current = selectedIds.map((element, i) => childRef.current[i] ?? createRef());
  const [state, setState] = useState({
    index: 0,
    loading: true,
  });
  const { index } = state;

  const {
    UserDetails: { userInfo },
  } = useSelector((prevState) => prevState);

  const findNameOfProduct = (id) => {
    const name = productData.find((dat) => dat._id === id);
    return name ? name.number : '';
  };
  const handleSubmit = async () => {
    const refContexts = childRef.current;
    const costingData = [];
    let error = 0;
    const errorDevorder = [];
    if (refContexts.length > 0) {
      await Promise.all(
        refContexts.map(async (item) => {
          const res = await item.current.submitFun();
          if (res?.save === false) {
            error++;
            errorDevorder.push(res.devOrderId);
          } else {
            costingData.push(res);
          }
        }),
      );
    }
    if (error === 0) {
      // api call
      const obj = {
        data: costingData,
      };
      setState((prev) => ({
        ...prev,
        loading: true,
      }));
      const res = await dispatch(multiProductSelectAction.addMultiProductCosting(obj));
      if (res) {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
        setProductCostingState((prev) => ({
          ...prev,
          show: false,
        }));
        if (res?.code === 200) {
          toasterMsg('Product Costings added Successfully', 'success');
        }
      }
    } else {
      const str = [];
      errorDevorder?.forEach((da) => {
        str?.push(findNameOfProduct(da));
      });
      const singleMsg = `Please fill the required fields of product ${str?.join(',')}`;
      const multiMsg = `Please fill the required fields of product(s) ${str?.join(',')}`;
      toasterMsg(errorDevorder?.length > 1 ? multiMsg : singleMsg, 'danger');
    }
  };

  const init = async () => {
    const postObj = { devOrderIds: [...selectedIds] };
    const currentProduct = productData?.find((dat) => dat._id === selectedIds[0]);
    const exchangRateReq = productData
      .map((x) => {
        if (x.seasonId && x.year) {
          return {
            seasonId: x.seasonId,
            year: x.year,
          };
        }
      })
      .filter((x) => x);
    dispatch(getAllUnitDetails({ loggedInUserId: userInfo?.userId }));
    dispatch(getCostingStageList({ loggedInUserId: userInfo?.userId, isActive: true }));

    dispatch(getCostingTemplateList({ isAllRecord: true }));
    dispatch(multiProductSelectAction.getProductInfoList(productData, commonSupplierList));
    dispatch(multiProductSelectAction.getProductTestingLibs(postObj));
    const bomLibs = await dispatch(multiProductSelectAction.getProductBOMLibs(postObj));
    if (exchangRateReq.length > 0) {
      dispatch(multiProductSelectAction.getExchangeRateList({ data: exchangRateReq }));
    }
    if (bomLibs) {
      await dispatch(multiProductSelectAction.setCurrentProductData(currentProduct));
    }
  };

  useEffect(() => {
    init();
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  }, []);

  const handleSelectCorousel = async (selectedIndex) => {
    const validation = childRef.current[index].current.checkValidation1();
    if (!validation) {
      const currentProduct = productData?.find((dat) => dat._id === selectedIds[selectedIndex]);
      await dispatch(multiProductSelectAction.setCurrentProductData(currentProduct));
      setState((prev) => ({
        ...prev,
        index: selectedIndex,
      }));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(multiProductSelectAction.clearMultipleCostingReducer());
    };
  }, [dispatch]);
  return (
    <Modal show={show} className="common-custom-modal new-costing-modal modal-bulk-costing">
      {state.loading ? (
        <Loader />
      ) : (
        <Carousel controls={selectedIds?.length > 1} interval={null} activeIndex={index} onSelect={handleSelectCorousel}>
          {selectedIds?.map((prduct, idx) => (
            <Carousel.Item key={`C${prduct}`}>
              <Modal.Header className="modal-header-custom">
                <Modal.Title style={{ flex: 'none' }} id="contained-modal-title-vcenter" className="xs-mb-title f-24">
                  <Link style={{ color: 'black' }} target="_blank" to={`/development-order/${prduct}/design-details/list`}>
                    {' '}
                    {findNameOfProduct(prduct)}
                  </Link>{' '}
                  {t('FILTER.PRODUCT_COSTING_INVITE')}({idx + 1}/{selectedIds?.length})
                </Modal.Title>
                <CustomTooltip tooltipText={t('COMMON_LABEL.CLOSE')}>
                  <span onClick={toggle} className="icon-close header-close cursor-pointer ml-auto" />
                </CustomTooltip>
              </Modal.Header>
              <Modal.Body className="pl-24 pr-24">
                <div className="container-fluid pl-0 pr-0">
                  <div className="full-width-block mt-2 mb-3">
                    <ProductCostingDetailView
                      index={idx}
                      globalIndex={index}
                      devOrderId={prduct}
                      ref={childRef.current[idx]}
                      findNameOfProduct={findNameOfProduct}
                    />
                  </div>
                </div>
                <div className="common-model-footer">
                  <CustomTooltip tooltipText={t('SETUP_2FA.SUBMIT')}>
                    <button aria-label={t('SETUP_2FA.SUBMIT')} type="button" onClick={handleSubmit} className="btn p-0">
                      <i className="icon-Tick-1 f-24" />
                    </button>
                  </CustomTooltip>
                </div>
              </Modal.Body>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </Modal>
  );
}
export default MultiProductCostingSubmitModal;
